import { useCallback, useContext, useMemo } from 'react';

import { OrderViewContext } from './order-view-utils';
import { OrderMailComposer } from './OrderMailComposer';
import { orderPlatforms } from './send-order-utils';

export const SendOrderView = () => {
  const {
    network,
    order,
    isNewOrder,
    flightChangeMap,
    generatePDF,
    setShowSendView,
    saving,
    setSaving,
    refetchOrder
  } = useContext(OrderViewContext);

  const platforms = useMemo(
    () => orderPlatforms(order.flights, flightChangeMap),
    [order, flightChangeMap]
  );
  const generate = useCallback(() => generatePDF(false), [generatePDF]);
  const close = useCallback(() => setShowSendView(false), [setShowSendView]);

  return (
    <OrderMailComposer
      order={order}
      network={network}
      isNewOrder={isNewOrder}
      platforms={platforms}
      generatePDF={generate}
      sending={saving}
      setSending={setSaving}
      onSent={refetchOrder}
      onClose={close}
    />
  );
};
